import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { FamilyMemberHistoryDetail } from '@liza/ui/components/records';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
};

export const FamilyMember = ({ id }: Props): React.ReactElement => {
  const { t } = useTranslation('records');
  const trpc = useTRPC();

  const familyMemberHistoryQuery = useQuery(trpc.patient.familyMemberHistory.get.queryOptions({ id }));

  return (
    <QueryStateHandler query={familyMemberHistoryQuery} emptyMessage={t('noFamilyHistoryFound')}>
      {(data) => <FamilyMemberHistoryDetail familyMemberHistory={data.familyMemberHistory} />}
    </QueryStateHandler>
  );
};
